import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { TableScrollTop } from '../../directives/table-scroll-top';

@Component({
  selector: 'app-hyde-park-winter-wonderland-privacy-notice',
  imports: [TableScrollTop],
  templateUrl: './hyde-park-winter-wonderland-privacy-notice.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './hyde-park-winter-wonderland-privacy-notice.scss',
})
export class HydeParkWinterWonderlandPrivacyNotice {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle =
    'Mari Group – Hyde Park Winter Wonderland Privacy Notice';
  protected readonly seoDescription =
    'Read the Hyde Park Winter Wonderland Privacy Notice, covering the personal information P W R Events Limited collects from ticket buyers, event attendees, and website visitors, and how it is used, shared, transferred, retained, and protected.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Privacy', path: '/privacy' },
        {
          name: 'Hyde Park Winter Wonderland Privacy Notice',
          path: '/hyde-park-winter-wonderland-privacy-notice',
        },
      ],
    });
  }
}
